import axiosAuthRequired from "@/api/axiosAuthRequired"
import { getAuthHeaders } from "@/constants/user"

export const fetchUserInventory = async () => {
  const response = await axiosAuthRequired({
    method: "GET",
    url: process.env.PROGUIDES_WEB_URL + "api/v2/user/inventory",
    headers: getAuthHeaders(),
  })
  return response.data
}



// WEBPACK FOOTER //
// ./src/store/user/inventory/inventory.apis.js